import { render, staticRenderFns } from "./BenefitNotificationBox2.vue?vue&type=template&id=c9970704&scoped=true"
import script from "./BenefitNotificationBox2.vue?vue&type=script&lang=js"
export * from "./BenefitNotificationBox2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9970704",
  null
  
)

export default component.exports